import { useState } from 'react';
import { Link } from 'react-router-dom';

const benefits = [
  'Breaking news before it hits social media',
  'Exclusive patch analysis & weapon tier lists',
  'Weekly esports recap and standings',
  'Early access to community events & giveaways',
];

export default function NewsletterCTA() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    const data = new URLSearchParams();
    data.append('email', email);
    fetch('https://readdy.ai/api/form/d70pm2pqa83q0hmd1f0g', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: data.toString(),
    })
      .then(() => { setSubmitted(true); setLoading(false); })
      .catch(() => setLoading(false));
  };

  return (
    <section className="border-t border-[#1e1e1e] bg-[#0d0d0d]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 border-x border-[#1e1e1e]">

          {/* Left block */}
          <div className="lg:col-span-2 p-10 border-b lg:border-b-0 lg:border-r border-[#1e1e1e]">
            <div className="flex items-center gap-2 mb-5">
              <span className="inline-block font-['Barlow_Condensed'] font-bold text-xs tracking-wider text-white bg-[#2a2a2a] border border-[#3a3a3a] px-2 py-0.5">
                NEWSLETTER
              </span>
              <span className="inline-block font-['Barlow_Condensed'] font-bold text-xs tracking-wider text-white bg-[#2a2a2a] border border-[#3a3a3a] px-2 py-0.5">
                FREE
              </span>
            </div>
            <h2 className="font-['Barlow_Condensed'] font-black text-white text-5xl uppercase leading-tight mb-5">
              Never Miss<br />An Update
            </h2>
            <ul className="space-y-3">
              {benefits.map((b) => (
                <li key={b} className="flex items-center gap-3 text-[#777] text-sm">
                  <span className="w-1.5 h-1.5 bg-[#00ff41] shrink-0" />
                  {b}
                </li>
              ))}
            </ul>
          </div>

          {/* Right form */}
          <div className="lg:col-span-1 p-10 flex flex-col justify-center">
            {submitted ? (
              <div className="text-center">
                <i className="ri-checkbox-circle-line text-[#00ff41] text-4xl mb-3 block" />
                <p className="font-['Barlow_Condensed'] font-black text-white text-xl uppercase">You&apos;re in, Operator!</p>
                <p className="text-[#555] text-sm mt-1">Check your inbox.</p>
              </div>
            ) : (
              <>
                <p className="text-[#555] text-xs font-['Barlow_Condensed'] font-bold tracking-widest uppercase mb-4">
                  Join 50K+ operators
                </p>
                <form
                  id="home-newsletter-form"
                  data-readdy-form
                  onSubmit={handleSubmit}
                  className="space-y-3"
                >
                  <input
                    type="email"
                    name="email"
                    placeholder="your@email.com"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full bg-[#111] border border-[#222] focus:border-[#444] text-white text-sm px-4 py-3 outline-none placeholder-[#444] transition-colors"
                  />
                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-[#00ff41] hover:bg-[#00e63a] text-black font-['Barlow_Condensed'] font-black text-sm tracking-widest py-3 transition-colors cursor-pointer disabled:opacity-50 whitespace-nowrap"
                  >
                    {loading ? 'SUBSCRIBING...' : 'SUBSCRIBE NOW'}
                  </button>
                </form>
                <p className="text-[#333] text-xs mt-3 text-center">
                  Free. No spam.{' '}
                  <Link to="/newsletter" className="text-[#555] hover:text-[#888] transition-colors cursor-pointer">
                    Learn more →
                  </Link>
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
